export interface ShopMarker {
  id: string;
  nameKey: string;
  position: {
    lat: number;
    lng: number;
  };
  image: string;
}

export const SHOPS_MARKERS: ShopMarker[] = [
  {
    id: "clothes",
    nameKey: "shops.clothes",
    position: { lat: -472, lng: 487 },
    image: "/map/store/chothes-store.webp",
  },
  {
    id: "furniture",
    nameKey: "shops.furniture",
    position: { lat: -474, lng: 503 },
    image: "/map/store/furniture-store.webp",
  },
  {
    id: "pets",
    nameKey: "shops.pets",
    position: { lat: -496.4, lng: 520.6 },
    image: "/map/store/pets-store.webp",
  },
  {
    id: "bookstore",
    nameKey: "shops.bookstore",
    position: { lat: -440, lng: 467 },
    image: "/map/store/books-store.webp",
  },
];
